import { AnnotationIconColorType } from '@/api/storymapCardDetails/queries';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createAddAnnotationCommand } from '../../../api/commands/factory/createAnnotationCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class AddAnnotation extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'AddAnnotation';

    public constructor(public id: string, public name: string, public color: AnnotationIconColorType, public icon: number) {
        super(AddAnnotation.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: AddAnnotation): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createAddAnnotationCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: AddAnnotation): void => {
    state.annotations.forEach(x => x.order++);
    state.annotations.push({
        color: action.color,
        emoji: null,
        id: action.id,
        isArchived: false,
        isEmoji: false,
        name: action.name,
        icon: action.icon,
        order: 0
    });
};

//@ts-ignore
registerMiddleware(AddAnnotation.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(AddAnnotation.ACTION_TYPE, reducer);
